import { Button, Drawer, Flex, Space } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { t } from "i18next";
import { onError } from "src/common/onError";
import { BulkPlanCreationStore } from "../BulkPlanCreationStore";
import styles from "./BulkPlanTempSelector.module.less";
import { SchedRowType } from "../../../SchedulingTypes";

interface PropsBulkPlanTempSelector {
  store: BulkPlanCreationStore;
}

export const BulkPlanTempSelector: React.FC<PropsBulkPlanTempSelector> =
  observer(({ store }) => {
    const [loading, setLoading] = useState(false);
    const { creationSettings } = store;
    const filterStore = creationSettings?.filterStore;
    if (!filterStore) return null;
    const handleClose = () => {
      store.setCreationSettings(null);
    };
    const handleOk = () => {
      setLoading(true);
      store
        .save()
        .finally(() => setLoading(false))
        .catch(onError);
    };
    const disabled = !filterStore.tableStore?.selected.length;
    const titleMap: Record<SchedRowType, string> = {
      [SchedRowType.plan]: t("Selecting a plan template"),
      [SchedRowType.group]: t("Selecting a task group template"),
      [SchedRowType.task]: t("Selecting a task template"),
    };
    return (
      <Drawer
        open={!!creationSettings}
        width="75vw"
        onClose={handleClose}
        title={
          <Flex align="center" justify="space-between">
            {titleMap[creationSettings.templateEntityType]}
            <Space>
              <Button onClick={handleClose} disabled={loading}>
                {t("Cancel")}
              </Button>
              <Button
                onClick={handleOk}
                disabled={disabled}
                loading={loading}
                type="primary"
              >
                {t("Create a calendar plan")}
              </Button>
            </Space>
          </Flex>
        }
        className={styles.drawer}
      >
        <EntityFiltersTable store={filterStore} />
      </Drawer>
    );
  });
